import React from 'react';
import ClientService from '../../../Services/clientService';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';

export default class AddExternalQuestionaireWindowDescription extends React.Component
{
    static titleForCreate = 'Add External Questionaire';
    static titleForEdit = 'Add External Questionaire';
    static itemType = AddExternalQuestionaireWindowDescription.getItemType;
    static serviceFunction = (edited) => ClientService.AddExternalQuestionaire(
        edited.EntityId, edited.EntityType, edited.TemplateName, edited.ThanksTemplateName, edited.ExpirationDate, edited.SubmittedTemplateName, edited.EnableMultipleResponses);


    static getItemType ()
    {
        // eslint-disable-next-line global-require
        return require('../../../Domain/ClientItem').default;
    }
    getSelected () { }

    getSearchParameters () { }

    getAllItemInTheSearchAreSelected () { }

    static pagesInGeneralEditWizzard = [
        {
            label: 'General',
            fields: [
                {
                    fieldName: 'Name',
                    label: 'Client Name',
                    className: 'col-12',
                    type: InputTypesEnum.TextReadOnly,
                },
                {
                    fieldName: 'TemplateName',
                    label: 'Template Name',
                    className: 'col-12',
                    type: InputTypesEnum.TextReadOnly,
                },
                {
                    fieldName: 'ThanksTemplateName',
                    label: 'ThanksTemplate Name',
                    className: 'col-12',
                    type: InputTypesEnum.TextReadOnly,
                },

                {
                    fieldName: 'SubmittedTemplateName',
                    label: 'SubmittedTemplate Name',
                    className: 'col-12',
                    type: InputTypesEnum.TextReadOnly,
                },
                {
                    fieldName: 'EnableMultipleResponses',
                    label: 'Enable Multiple Responses',
                    className: 'col-12',
                    type: InputTypesEnum.TextReadOnly,
                },
                {
                    fieldName: 'ExpirationDate',
                    label: 'Expiration Date',
                    className: 'col-12',
                    type: InputTypesEnum.TextReadOnly,
                },
                {
                    fieldName: 'InfoText',
                    label: 'Info',
                    className: 'col-12',
                    type: InputTypesEnum.TextReadOnly,
                },
            ],
        },
    ];
}
